// extracted by mini-css-extract-plugin
export default {"footerWrapper":"footer_footerWrapper__qBvbm","footerLeft":"footer_footerLeft__pobQF","termsLink":"footer_termsLink__jw+YD","dark":"footer_dark__2HmI+"};